import { authApi } from './index';

export const registerSSOMatchers = [
	authApi.endpoints.registerGoogle.matchFulfilled,
	authApi.endpoints.registerDiscord.matchFulfilled,
];

export const registerMatchers = [
	...registerSSOMatchers,
	authApi.endpoints.register.matchFulfilled,
];

export const loginSSOMatchers = [
	authApi.endpoints.googleLogin.matchFulfilled,
	authApi.endpoints.discordLogin.matchFulfilled,
];

export const loginMatchers = [
	...loginSSOMatchers,
	authApi.endpoints.login.matchFulfilled,
];
